var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2203_12417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.3784C11.8786 22.3784 11.7572 22.347 11.6485 22.2842C11.5304 22.2161 8.72392 20.5866 5.8772 18.1314C4.18999 16.6763 2.84318 15.233 1.87427 13.8417C0.620464 12.0415 -0.0100507 10.3098 0.000121129 8.69482C0.0120274 6.8156 0.685104 5.04833 1.89551 3.71848C3.12635 2.36624 4.76894 1.62158 6.5208 1.62158C8.76596 1.62158 10.8187 2.87924 12.0001 4.87151C13.1814 2.87928 15.2341 1.62158 17.4793 1.62158C19.1344 1.62158 20.7134 2.29349 21.9258 3.51355C23.2563 4.85243 24.0123 6.74421 23.9999 8.70372C23.9897 10.3159 23.3473 12.0449 22.0908 13.8427C21.1189 15.2333 19.7739 16.6759 18.0933 18.1306C15.257 20.5856 12.4707 22.215 12.3535 22.2831C12.2442 22.3466 12.1221 22.3784 12 22.3784Z",
    fill: "#E25297"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2203_12417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFilled);
export default __webpack_public_path__ + "static/media/favoriteFilled.34edab6aa15830f1531ab4f12186859b.svg";
export { ForwardRef as ReactComponent };